import request from '@/utils/request'

export function fetchData() {
    return request({
        url: '/admin/setting/get',
        method: 'get',
    })
}

export function save(data) {
    return request({
        url: '/admin/setting/save',
        method: 'post',
        data
    })
}
